import React, { useCallback } from 'react';
import { type Href, Link } from 'expo-router';

import { Navbar } from '@garnish/navigation';

import { useTelemetry } from '@order/Telemetry';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarMoreContentLink = (props: Props) => {
  const { link, isNewLink, shouldDismissModal, onPress, variant } = props;

  const { track } = useTelemetry();

  // ─── Handlers ────────────────────────────────────────────────────────

  const handlePress = useCallback(() => {
    track('nav_more_content_selected', { title: link.title, url: link.url });
    onPress();
  }, [link.title, link.url, onPress, track]);

  // ─────────────────────────────────────────────────────────────────────

  if (variant === 'drawer') {
    return (
      <Link asChild withAnchor dismissTo={shouldDismissModal} href={link.url as Href}>
        <Navbar.Floating.Drawer.NavLink onPress={handlePress}>
          {link.title}
        </Navbar.Floating.Drawer.NavLink>
      </Link>
    );
  }

  return (
    <Link asChild withAnchor dismissTo={shouldDismissModal} href={link.url as Href}>
      <Navbar.Floating.PageLink
        title={link.title}
        description={link.text}
        isNewLink={isNewLink}
        imageSrc={link.imageSrc}
        imageAlt={link.imageAlt}
        onPress={handlePress}
      />
    </Link>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  link: MoreMenuLink;
  isNewLink?: boolean;
  shouldDismissModal?: boolean;
  onPress: () => void;
  variant: 'drawer' | 'page';
};

type MoreMenuLink = {
  title: string;
  text?: string;
  url: string;
  imageAlt: string;
  imageSrc: string;
};
